import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql, compose, Subscription } from "react-apollo";
import { Link } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
// material
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import TablePagination from "@material-ui/core/TablePagination";
import Typography from "@material-ui/core/Typography";
import Search from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import { FaEdit, FaFileExport } from "react-icons/fa";
import { MdAdd, MdCheckCircle, MdRemoveCircle } from "react-icons/md";
import { Grid } from "@material-ui/core";
import { CSVLink } from "react-csv";

import { archiveConsumer, unarchiveConsumer, addDealCoinsAdmin } from "./mutation";
import AddRDCDialogContent from "./AddRDCDialogContent";
import { createNotifications } from "../../Notifications/mutations";
import { getAllConsumers } from "./queries";
import { Dialog } from "../../../../components";
import NotificationModal from "../../../../components/NotificationModal/NotificationModal";
import styles from "./styles";
import { colors } from "../../../../constants";
import FilterFromToV2 from "../../../../components/Filter/FilterFromToV2";
import { subConsumerEvent } from "../../Subscription";

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: colors.parimary,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

class TableConsumer extends Component {
  state = {
    open: false,
    openAddRDC: false,
    openNotificationModal: false,
    title: "",
    content: "",
    search: "",
    page: 0,
    limit: 15,
    listCheckId: [],

    // filter
    email: "",
    dateFrom: "",
    dateTo: "",
    archived: "",
    deleteAccount: false,
    confirmTypeBalanceWallet: "",
    confirmTypeBalanceWalletMessage: "",
    inputValBalance: 0,
    dataUser: null,
  };

  onDataRefetch(){
    const { listRefetch } = this.props;
    listRefetch.refetch()
  }

  componentDidMount(){
    this.onDataRefetch()
  }

  componentDidUpdate(){
    this.onDataRefetch()
  }

  onArchive = (row) => {
    const { id } = row;
    const { archiveConsumer } = this.props;
    archiveConsumer({
      variables: {
        id,
      },
      refetchQueries: [{ query: getAllConsumers }],
    })
      .then((res) => {
        if (res)
          this.setState({
            open: true,
            content: "Completed",
            title: "Active Consumer",
          });
      })
      .catch(({ graphQLErrors }) => {
        if (graphQLErrors) {
          this.setState({
            open: true,
            content: graphQLErrors[0].message,
            title: "Active Consumer",
          });
        }
      });
  };

  onOk = () => {
    this.setState({ open: false });
  };

  handleAddRDCClick = (dataUser) => {
    this.setState({ openAddRDC: true, dataUser });
  };

  renderAddRDCDialog = (data) => {
    return (
      <AddRDCDialogContent data={data}>
        <Grid>
          <Typography style={{ fontSize: 14 }} variant="caption">
            Type of DealCoins
          </Typography>
          <Select
            name="confirmTypeBalanceWallet"
            onChange={this.handleFilterInpChange}
            value={this.state.confirmTypeBalanceWallet}
            displayEmpty
            style={{ width: "100%" }}
          >
            <MenuItem value="">
              <em>Select Type</em>
            </MenuItem>
            <MenuItem value="rdc">Reserved DealCoins (RDC)</MenuItem>
            <MenuItem value="edc">Earned DealCoins (EDC)</MenuItem>
          </Select>
        </Grid>
        <Grid style={{ marginTop: 10 }}>
          <Typography style={{ fontSize: 14 }} variant="caption">
            Add the amount
          </Typography>
          <TextField
            name="inputValBalance"
            value={this.state.inputValBalance}
            onChange={this.handleFilterInpChange}
            type="number"
            placeholder="Amount"
            style={{ width: "100%" }}
          />
        </Grid>
        <Grid>
          <Typography style={{ fontSize: 14 }} variant="caption">
            detail of the operation
          </Typography>
          <TextField
            name="confirmTypeBalanceWalletMessage"
            value={this.state.confirmTypeBalanceWalletMessage}
            onChange={this.handleFilterInpChange}
            type="text"
            placeholder="Message"
            style={{ width: "100%" }}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
      </AddRDCDialogContent>
    );
  };

  onOkAddRDC = () => {
    const { wallet, username } = this.state.dataUser;
    const { confirmTypeBalanceWallet, inputValBalance, confirmTypeBalanceWalletMessage } = this.state;
    const { addDealCoinsAdmin: addDealCoinsAdminMutation } = this.props;

    if (Number.parseInt(inputValBalance, 10) === 0) {
      this.setState({
        open: true,
        content: "The value is not allowed to be zero (0)",
        title: "Add or remove Deal Coins",
      });
      return;
    }

    addDealCoinsAdminMutation({
      variables: {
        idWallet: wallet.id,
        type: confirmTypeBalanceWallet,
        amount: Number.parseInt(inputValBalance, 10),
        detail: confirmTypeBalanceWalletMessage,
      },
      refetchQueries: [{ query: getAllConsumers }],
    })
      .then((res) => {
        const operation = Number.parseInt(inputValBalance, 10) < 0 ? "removed" : "added";
        if (res) {
          this.setState({
            open: true,
            content: `${Math.abs(Number.parseInt(inputValBalance, 10))} ${confirmTypeBalanceWallet.toUpperCase()} are ${operation} to the Wallet user ${username}`,
            title: "Add/Remove Deal Coins",
          });
        }
        this.setState({
          openAddRDC: false,
          inputValBalance: 0,
          confirmTypeBalanceWallet: "",
          confirmTypeBalanceWalletMessage: "",
          dataUser: null,
        });
      })
      .catch(({ graphQLErrors }) => {
        if (graphQLErrors) {
          this.setState({
            open: true,
            content: graphQLErrors[0].message,
            title: "Errors add Deal Coins",
            openAddRDC: false,
            inputValBalance: 0,
            confirmTypeBalanceWallet: "",
            confirmTypeBalanceWalletMessage: "",
            dataUser: null,
          });
        }
      });
  };

  renderDialogChildren = () => {
    if (!this.state.openAddRDC) return null;
    return this.renderAddRDCDialog(this.state.dataUser);
  };

  onUnarchive = (row) => {
    const { id } = row;
    const { unarchiveConsumer } = this.props;
    unarchiveConsumer({
      variables: {
        id,
      },
      refetchQueries: [{ query: getAllConsumers }],
    })
      .then((res) => {
        if (res)
          this.setState({
            open: true,
            content: "Completed",
            title: "Unactive Consumer",
          });
      })
      .catch(({ graphQLErrors }) => {
        if (graphQLErrors) {
          this.setState({
            open: true,
            content: graphQLErrors[0].message,
            title: "Unactive Consumer",
          });
        }
      });
  };

  onSelectAllClick = (data) => {
    const { listCheckId } = this.state;
    const currentPageData = data.slice(this.state.page * this.state.limit, this.state.page * this.state.limit + this.state.limit);
    const currentPageIds = currentPageData.map(item => item.id);
    
    // Si todos los elementos de la página actual están seleccionados, deseleccionar todos
    const allSelected = currentPageIds.every(id => listCheckId.includes(id));
    
    if (allSelected) {
      // Deseleccionar todos los elementos de la página actual
      const newListCheckId = listCheckId.filter(id => !currentPageIds.includes(id));
      this.setState({ listCheckId: newListCheckId });
    } else {
      // Seleccionar todos los elementos de la página actual que no estén ya seleccionados
      const newListCheckId = [...listCheckId];
      currentPageIds.forEach(id => {
        if (!newListCheckId.includes(id)) {
          newListCheckId.push(id);
        }
      });
      this.setState({ listCheckId: newListCheckId });
    }
  };

  onSelectCheckbox = (row) => {
    let { listCheckId } = this.state;
    if (_.indexOf(listCheckId, row.id) < 0) {
      listCheckId.push(row.id);
    } else {
      listCheckId = _.filter(listCheckId, (item) => item !== row.id);
    }
    this.setState({ listCheckId });
  };

  onOpenNotificationModal = () => {
    this.setState({ openNotificationModal: true });
  };

  onCloseNotificationModal = () => {
    this.setState({ openNotificationModal: false });
  };

  onSubmitNotification = (input) => {
    const { createNotifications } = this.props;
    createNotifications({
      variables: { input },
    })
      .then((res) => {
        if (res) {
          this.setState({
            open: true,
            content: "Notificaciones enviadas exitosamente",
            title: "Enviar Notificaciones",
            openNotificationModal: false,
            listCheckId: [],
          });
        }
      })
      .catch(({ graphQLErrors }) => {
        if (graphQLErrors) {
          this.setState({
            open: true,
            content: graphQLErrors[0].message,
            title: "Error al enviar notificaciones",
          });
        }
      });
  };

  onSearch = (event) => {
    this.setState({ search: event.target.value });
  };

  handleFilterInpChange = (event) => {
    let { name, value } = event.target;
    /*if (value.toLowerCase) {
      value = value.toLowerCase();
    }*/

    this.setState({ [name]: value });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ limit: event.target.value });
  };

  filter = (data) => {
    const { search, email, dateTo, dateFrom, archived } = this.state;
    
    if (search)
      data = _.filter(data, (obj) =>
        obj.username.toLowerCase().match(search.toLowerCase())
      );

    if (email) {
      data = _.filter(data, (v) => v.email && v.email.includes(email));
    }

    if (archived !== "") {
      data = _.filter(data, (v) => v.archived === archived);
    }   

    if (dateFrom) {
      data = _.filter(data, (v) => {
        const createdAt = moment.isMoment(v.createdAt) 
          ? v.createdAt 
          : moment(Number(v.createdAt));
        return createdAt.isSameOrAfter(dateFrom, "day");
      });
    }

    if (dateTo) {
      data = _.filter(data, (v) => {
        // Si createdAt es un objeto moment, usar directamente, si no, convertirlo
        const createdAt = moment.isMoment(v.createdAt) 
          ? v.createdAt 
          : moment(Number(v.createdAt));
        return createdAt.isSameOrBefore(dateTo, "day");
      });
    }

    return data;
  };

  prepareDataForCSV = () => {
    const { ListAllConsumer } = this.props;
    let data = ListAllConsumer || [];
    
    // Formatear los datos igual que en el render
    data = _.map(data, (v) => ({
      ...v,
      createdAt: moment(Number(v.createdAt)),
    }));
    
    // Aplicar los mismos filtros que se usan en la tabla
    data = _.orderBy(data, (obj) => obj.id, "desc");
    data = this.filter(data);
    
    // Formatear los datos para CSV - solo los consumers que cumplen los filtros
    return data.map((consumer) => {
      let review = 0;
      if (consumer.reviews && consumer.reviews.length > 0) {
        _.forEach(consumer.reviews, (item) => (review += item.votedStars));
        review = Math.round(review / consumer.reviews.length);
      } else {
        review = 5;
      }
      
      const wallet = consumer.wallet || {};
      return {
        Username: consumer.username || '',
        Email: consumer.email || '',
        Review: review,
        'Balance Wallet ($)': wallet.earnedDealCoin || 0,
        Activated: consumer.archived ? 'No' : 'Yes',
        'Sign Up Date': consumer.createdAt ? consumer.createdAt.format('MM/DD/YYYY') : '',
        'Delete Account': consumer.deleteAccount ? 'Yes' : 'No',
      };
    });
  };

  onExportToCSV = () => {
    if (this.csvLinkRef) {
      this.csvLinkRef.link.click();
    }
  };

  renderToolBar = () => {
    const { classes } = this.props;
    const { listCheckId } = this.state;
    return (
      <div className={classes.searchWrapper}>
        {listCheckId.length > 0 ? (
          <Button
            variant="contained"
            color="secondary"
            className={classes.buttonActive}
            onClick={this.onOpenNotificationModal}
            style={{ minWidth: '200px' }}
          >
            <Typography component="p" className={classes.text}>
              Enviar notificaciones
            </Typography>
          </Button>
        ) : null}
        <Button
          variant="contained"
          color="primary"
          className={classes.buttonActive}
          onClick={this.onExportToCSV}
        >
          <Typography component="p" className={classes.text}>
            Export
          </Typography>
        </Button>
        <CSVLink
          data={this.prepareDataForCSV()}
          filename={`consumers-${moment().format('YYYY-MM-DD-HHmmss')}.csv`}
          style={{ display: "none" }}
          ref={(r) => this.csvLinkRef = r}
        >
          Export
        </CSVLink>
      </div>
    );
  };

  renderFilter = () => {
    const { classes } = this.props;
    return (
      <div key="filter">
        <div className={classes.filterRow}>
          <FilterFromToV2
            label="Username"
            fromField={
              <TextField
                name="search"
                value={this.state.search}
                onChange={this.onSearch}
                placeholder="Username"
              />
            }
            resetFn={() => this.setState({ search: "" })}
            smallButton
          />
          <FilterFromToV2
            label="Email"
            fromField={
              <TextField
                name="email"
                value={this.state.email}
                onChange={this.handleFilterInpChange}
                placeholder="Email"
              />
            }
            resetFn={() => this.setState({ email: "" })}
            smallButton
          />
          <FilterFromToV2
            label="Activation"
            fromField={
              <Select
                name="archived"
                onChange={this.handleFilterInpChange}
                value={this.state.archived}
                displayEmpty
              >
                <MenuItem value={""}>
                  <em>All</em>
                </MenuItem>
                <MenuItem value={false}>Activated</MenuItem>
                <MenuItem value={true}>Deactivated</MenuItem>
              </Select>
            }
            resetFn={() => this.setState({ archived: "" })}
            smallButton
          />
        </div>
        <div className={classes.filterRow}>
          <FilterFromToV2
            label="Created Date"
            fromField={
              <TextField
                name="dateFrom"
                type="date"
                value={this.state.dateFrom}
                onChange={this.handleFilterInpChange}
                placeholder="From"
              />
            }
            toField={
              <TextField
                name="dateTo"
                type="date"
                value={this.state.dateTo}
                onChange={this.handleFilterInpChange}
                placeholder="To"
              />
            }
            resetFn={() => this.setState({ dateFrom: "", dateTo: "" })}
            smallButton
          />
        </div>
      </div>
    );
  };

  render() {
    const { classes, ListAllConsumer } = this.props;    
    
    // let data = ListAllConsumer || [];
    let data = ListAllConsumer || [];    
    data = _.map(data, (v) => ({
      ...v,
      createdAt: moment(Number(v.createdAt)),
    }));

    data = _.orderBy(data, (obj) => obj.id, "desc");
    const {
      title, content, open, openAddRDC, openNotificationModal, page, limit, listCheckId,
    } = this.state;
    data = this.filter(data);

    return (
      <div>
        <Dialog
          title={title}
          content={content}
          open={open}
          onOk={() => this.onOk()}
        />
        <Dialog
          title="Add/Remove Deal Coins"
          listChildren={this.renderDialogChildren()}
          open={openAddRDC}
          onOk={() => this.onOkAddRDC()}
          onCancel={() => this.setState({
            openAddRDC: false,
            inputValBalance: 0,
            confirmTypeBalanceWallet: "",
            confirmTypeBalanceWalletMessage: "",
            dataUser: null,
          })}
        />
        <NotificationModal
          open={openNotificationModal}
          onClose={this.onCloseNotificationModal}
          onSubmit={this.onSubmitNotification}
          selectedUserIds={[]}
          selectedConsumerIds={listCheckId}
        />
        {this.renderFilter()}
        {this.renderToolBar()}
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <CustomTableCell padding="checkbox">
                  <Checkbox
                    checked={
                      listCheckId.length ===
                      data.slice(page * limit, page * limit + limit).length
                    }
                    onChange={() =>
                      this.onSelectAllClick(
                        data.slice(page * limit, page * limit + limit)
                      )
                    }
                  />
                </CustomTableCell>
                <CustomTableCell>Username</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>
                  Email
                </CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>
                  Review
                </CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>
                  Wallet EDC/RDC
                </CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>
                  Activated
                </CustomTableCell>
                <CustomTableCell align="right" className={classes.rowEdit}>
                  Edit
                </CustomTableCell>
                <CustomTableCell align="center" className={classes.rowEdit}>
                  Activate/Deactivate
                </CustomTableCell>
                <CustomTableCell align="center" className={classes.rowEdit}>
                  {/* Created At */}
                  Sign Up date
                </CustomTableCell>
                <CustomTableCell align="center" className={classes.columnRow}>                  
                  Delete Account
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * limit, page * limit + limit).map((row) => {
                let review = 0;
                if (row.reviews.length > 0) {
                  _.forEach(row.reviews, (item) => (review += item.votedStars));
                  review = Math.round(review / row.reviews.length);
                } else review = 5;
                return (
                  <TableRow className={classes.row} key={row.id}>
                    <CustomTableCell padding="checkbox">
                      <Checkbox
                        checked={_.indexOf(listCheckId, row.id) >= 0}
                        onChange={() => this.onSelectCheckbox(row)}
                      />
                    </CustomTableCell>
                    <CustomTableCell component="th" scope="row">
                      {row.username}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.email}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {review}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTableBalance}>
                      {`${row.wallet.earnedDealCoin || 0} / ${row.wallet.reservationOnly || 0}`}
                      {!row.archived && row.wallet && (
                        <MdAdd
                          color={colors.dark}
                          size={20}
                          style={{ cursor: "pointer" }}
                          className={classes.btnBalance}
                          onClick={() => this.handleAddRDCClick(row)}
                        />
                      )}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {!row.archived ? (
                        <MdCheckCircle color={colors.dark} size={16} />
                      ) : (
                        <MdRemoveCircle color={colors.red} size={16} />
                      )}
                    </CustomTableCell>
                    <CustomTableCell
                      align="center"
                      className={classes.columCenter}
                    >
                      <Link to={{ pathname: `/detailConsumer/${row.id}` }}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                        >
                          <Typography component="p" className={classes.text}>
                            Edit
                          </Typography>
                          <FaEdit color="#ffffff" size={16} />
                        </Button>
                      </Link>
                    </CustomTableCell>
                    <CustomTableCell
                      align="center"
                      className={classes.columCenter}
                    >
                      {!row.archived ? (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.buttonActive}
                          onClick={() => this.onArchive(row)}
                        >
                          <Typography component="p" className={classes.text}>
                            Deactivate
                          </Typography>
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.buttonDeactive}
                          onClick={() => this.onUnarchive(row)}
                        >
                          <Typography component="p" className={classes.text}>
                            Activate
                          </Typography>
                        </Button>
                      )}
                    </CustomTableCell>
                    <CustomTableCell component="th" scope="row">
                      {row.createdAt.format("MM/DD/YYYY")}
                    </CustomTableCell>
                    <CustomTableCell align="right" component="th" scope="row">                      
                      {!row.deleteAccount ? (
                        <MdRemoveCircle color={colors.red} size={16} />
                        ) : (
                        <MdCheckCircle color={colors.dark} size={16} />
                      )}
                    </CustomTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[15, 25, 50]}
            component="div"
            count={data.length}
            rowsPerPage={limit}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
          <Subscription
            subscription={subConsumerEvent}            
            onSubscriptionData={({ subscriptionData }) => {
              this.onDataRefetch()
            }}>          
          </Subscription>
        </Paper>
      </div>
    );
  }
}

// Mark: default props
TableConsumer.defaultProps = {  
  classes: {},
  archiveConsumer: () => {},
  unarchiveConsumer: () => {},
  addDealCoinsAdmin: () => {},
  ListAllConsumer: [],
  listRefetch: () => {},
  createNotifications: () => {},
};

// Mark: PropsType
TableConsumer.propTypes = {
  classes: PropTypes.object,
  archiveConsumer: PropTypes.func,
  unarchiveConsumer: PropTypes.func,
  addDealCoinsAdmin: PropTypes.func,
  ListAllConsumer: PropTypes.array,
  listRefetch: PropTypes.func,
  createNotifications: PropTypes.func,
};
const ListAllConsumer = graphql(getAllConsumers, {
  props: ({ data }) => ({
    loadingList: data.loading,
    ListAllConsumer: data.getAllConsumers
  }),
});
const listRefetch = graphql(getAllConsumers, { name: "listRefetch"});
const Archive = graphql(archiveConsumer, { name: "archiveConsumer" });
const Unarchive = graphql(unarchiveConsumer, { name: "unarchiveConsumer" });
const CreateNotifications = graphql(createNotifications, {
  name: "createNotifications",
});
const AddDealCoinsAdmin = graphql(addDealCoinsAdmin, {
  name: "addDealCoinsAdmin",
});

export default withStyles(styles)(
  compose(
    ListAllConsumer,
    listRefetch,
    Archive,
    Unarchive,
    CreateNotifications,
    AddDealCoinsAdmin
  )(TableConsumer)
);
